module.exports = __webpack_public_path__ + "d062b0cbc450a8e7dfe6493038df0127.svg";